/**
 * Sticky Add to Cart Button
 * 在移动端滚动超出购买按钮后,在底部显示固定的购买按钮
 */

class StickyAddButton {
  constructor() {
    this.stickyButton = document.querySelector('[data-sticky-button]');
    if (!this.stickyButton) return;
    
    this.sectionId = this.stickyButton.dataset.section;
    
    this.addToCartButton = document.getElementById(`Product-Submit-Button-${this.sectionId}`);
    
    if (!this.addToCartButton) {
      console.warn('StickyAddButton: Could not find add to cart button with ID:', `Product-Submit-Button-${this.sectionId}`);
      return;
    }
    
    this.formContainer = this.addToCartButton.closest('.product-form-buttons') 
      || this.addToCartButton.closest('product-form');
    
    // console.log('Found button:', this.addToCartButton.id, 'Container:', this.formContainer);
    this.init();
  }

  init() {
    if (window.innerWidth >= 750) return;
    
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    this.handleScroll();
    
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 750) {
        this.stickyButton.classList.add('hidden');
      }
    });
    
    this.setupVariantChange();
  }
  
  handleScroll() {
    const target = this.formContainer || this.addToCartButton;
    const rect = target.getBoundingClientRect();
    const buttonBottom = rect.bottom;
    
    // console.log('Container bottom:', buttonBottom, 'top:', rect.top);
    
    if (buttonBottom < 0) {
    //   console.log('Show sticky button');
      this.stickyButton.classList.remove('hidden');
    } else {
    //   console.log('Hide sticky button');
      this.stickyButton.classList.add('hidden');
    }
  }

  setupVariantChange() {
    if (typeof webvista !== 'undefined' && webvista.subscribe && typeof PUB_SUB_EVENTS !== 'undefined') {
      webvista.subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== this.sectionId) return;
        
        const button = this.stickyButton.querySelector('button');
        if (button && event.data.variant) {
          if (event.data.variant.available === false) {
            button.disabled = true;
          } else {
            button.disabled = false;
          }
        }
      });
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyAddButton();
  });
} else {
  new StickyAddButton();
}
